export const chartLegends = {
  clinicianStatsInProgress: "In Progress Evaluations",
  clinicianStatsSigned: "Signed Evaluations",
  clinicianStatsCompleted: "Completed Evaluations"
};
